import { createContent } from '@altify/utils';

export const content = createContent({
  en: {
    title: 'Information Updated',
    submittedTitle: 'Information Submitted',
  },
  de: {
    title: 'Informationen aktualisiert',
    submittedTitle: 'Übermittelte Informationen',
  },
});
